import React, { useState } from 'react';

const MAX_LENGTH = 500;

interface LessonCommentFormProps {
  submitting: boolean;
  onSubmit: (content: string) => Promise<void>;
}

const LessonCommentForm: React.FC<LessonCommentFormProps> = ({ submitting, onSubmit }) => {
  const [content, setContent] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!content.trim() || submitting) {
      return;
    }

    try {
      await onSubmit(content.trim());
      setContent('');
    } catch {
      // erro já é tratado e exibido pelo componente pai
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mt-4">
      <textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        disabled={submitting}
        maxLength={MAX_LENGTH}
        placeholder="Escreva um comentário..."
        rows={3}
        className="w-full border border-gray-300 rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-terracota disabled:opacity-50 disabled:cursor-not-allowed"
      />
      <div className="flex items-center justify-between mt-2">
        <span className="text-xs text-gray-400">{content.length}/{MAX_LENGTH}</span>
        <button
          type="submit"
          disabled={submitting || !content.trim()}
          className={`px-4 py-2 text-sm rounded-lg bg-terracota text-white hover:bg-red-700 transition flex items-center justify-center gap-2 ${
            submitting || !content.trim() ? 'cursor-not-allowed opacity-50' : ''
          }`}
        >
          {submitting ? (
            <>
              <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
              </svg>
              Enviando...
            </>
          ) : (
            'Comentar'
          )}
        </button>
      </div>
    </form>
  );
};

export default LessonCommentForm;
